import { render } from "./ToolsAndApps.vue?vue&type=template&id=07b2f0f3&scoped=true"
import script from "./ToolsAndApps.vue?vue&type=script&lang=js"
export * from "./ToolsAndApps.vue?vue&type=script&lang=js"

import "./ToolsAndApps.vue?vue&type=style&index=0&id=07b2f0f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b2f0f3"]])

export default __exports__